import { put, call } from 'redux-saga/effects';

import { verifyChangePassRequest } from '@api/user';
import { toastError } from '@store/notifications';

export const handleVerifyChangePasswordSaga = function* ({ payload }) {
  try {
    yield call(verifyChangePassRequest, payload);
  } catch (error) {
    const { nonFieldErrors, hasNonFieldError } = error.data || {};

    yield put(
      toastError({
        message: hasNonFieldError
          ? nonFieldErrors
          : {
              defaultMessage: 'Password change token is invalid.',
              id: 'components.reset-password-form.response.invalid',
            },
      })
    );
  }
};
